import axios from 'axios';

export const HTTP = axios.create({
  headers: { 
    'content-type': 'application/json'
  }
})

export const UTILS = { 
    downloadDocument: function(response) {
                var link=document.createElement('a');

                var fileName = response.headers['x-file-name'];
                var contentType = response.headers['content-type'];
                var blob = new Blob([response.data], {type: contentType});


                //Soporte IE
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                   window.navigator.msSaveOrOpenBlob(blob, fileName);
                   return;
                 }

                var url= window.URL.createObjectURL(blob);
                link.href= url;
                link.download=fileName;
                document.body.appendChild(link);
                link.click();

                setTimeout(function(){
                       document.body.removeChild(link);
                       window.URL.revokeObjectURL(url);
                   }, 1000);
      }
    
} 